import cartItem from './vueComponents/cartItem.js';
import Autocomplete from '@trevoreyre/autocomplete-vue';


export default {
    name : 'header',

    init()
    {
        if (document.getElementById('header')) {
            this.run();
        }
    },
    run ()
    {
        window['header'] = new Vue({
            el: '#header',

            delimiters: ['@{','}'],

            components:
            {
              Autocomplete
            },

            data :
            {
                lastScrollTop : 0,
                cssClasses : [],

                // cart
                cartReady : false,
                cartItems : [],
                currency : null,
                mainMenuToggled : false,
                cartToggled : false,


                // search
                headerSearchToggled : false,
                input : "",
                searchIndexItems : [],
                link  : "",
            },

            filters: {
                nok (value)
                {
                    if (!Number.isInteger(value)) {
                        return null;
                    }

                    // value = (value >0) ? value/100 : value;
                    value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                    // return value + this.currency;
                    return value + ',-';
                }
            },

            computed :
            {
                headerClass ()
                {
                    return this.cssClasses.join(' ');
                },

                hasItems ()
                {
                    return (this.cartItems && typeof this.cartItems==='object' && this.cartItems.length) ?
                            'hasItems' :
                            '';
                },

                cartAmount ()
                {
                    let amount = 0;

                    if (this.cartItems && typeof this.cartItems==='object' && this.cartItems.length) {
                        amount = this.cartItems.reduce((total, cartItem) => {
                                        return total + (parseInt(cartItem.totals.line_total) + parseInt(cartItem.totals.line_total_tax));
                                    },
                                    amount // init value
                                );
                    }

                    return amount;
                },

                totalAmount ()
                {
                    return this.cartAmount;
                },

                shippingAmount ()
                {
                    return (this.cartAmount === 0 || this.cartAmount >= 500) ? 0 : 100;
                },

                headerSearchClass ()
                {
                    return (this.headerSearchToggled) ? 'showSearch' : 'hidden';
                }
            },

            methods:
            {
                vanishMenus()
                {
                    this.cartToggled = false;
                    this.mainMenuToggled = false;
                    document.querySelector('html').classList.remove('blured');
                    this.cssClasses = [];
                },

                initWindowScroll ()
                {
                    window.addEventListener('scroll', this.handleScrollStatus);
                },

                handleScrollStatus (event)
                {
                    const currentScrollY  = window.scrollY;
                    const scrolled = (currentScrollY >= 130 && currentScrollY >= this.lastScrollTop) ? true : false;

                    const className = 'scrolled';
                    if (scrolled) {
                        this.addHeaderClass(className);
                    } else {
                        this.removeHeaderClass(className);
                    }

                    this.lastScrollTop = currentScrollY;
                },

                addHeaderClass ( className )
                {
                    const index = this.cssClasses.indexOf(className);
                    if (index === -1) {
                        this.cssClasses.push(className);
                    }
                },

                removeHeaderClass ( className )
                {
                    const index = this.cssClasses.indexOf(className);
                    if (index > -1) {
                        this.cssClasses.splice(index, 1);
                    }
                },


                /************************************************************************
                                        Main menu
                *************************************************************************/

                toggleMainMenu (event)
                {
                    event.preventDefault();
                    document.querySelector('html').classList.toggle('blured');

                    this.mainMenuToggled = (this.mainMenuToggled) ? false : true;
                    this.cssClasses = (this.mainMenuToggled) ? ['active'] : [];
                },


                /************************************************************************
                                        Cart
                *************************************************************************/

                toggleCart (event)
                {
                    event.preventDefault();
                    document.querySelector('html').classList.toggle('blured');

                    this.cartToggled = (this.cartToggled) ? false : true;
                    this.cssClasses = (this.cartToggled) ? ['showCart'] : [];
                },

                updateCart()
                {
                    this.getCartItems();
                    this.addAnimation();
                },

                addAnimation()
                {
                    document.getElementById('toggleCartBtn').classList.add('animate');
                },

                removeAnimation()
                {
                    setTimeout(function() {
                        document.getElementById('toggleCartBtn').classList.remove('animate');
                        },
                        1000
                    );
                },

                getCartItems()
                {
                    wcRest.getCartItems(this.setCartItems);
                },

                setCartItems (response)
                {
                    if (typeof response.data ==='object' && response.data.length) {
                        this.cartItems = response.data;
                    } else {
                        this.cartItems = [];
                    }

                    this.cartReady = true;
                    this.addHeaderClass('cartReady');
                    this.removeAnimation();
                },


                /************************************************************************
                                        Search
                *************************************************************************/

                toggleHeaderSearch ()
                {
                    this.vanishMenus();

                    this.headerSearchToggled = !this.headerSearchToggled;

                    // if (this.headerSearchToggled) {
                    //     setTimeout(function() {
                    //         document.getElementById('searchFormInput').focus({preventScroll:true});
                    //     },
                    //     500);
                    // }
                },

                getResultValue (item)
                {

                    this.link = item.permalink;
                    return item.title;
                },

                submitSearch( event )
                {
                    const input = this.input.trim();

                    if (input.length < 3) {
                        event.preventDefault();
                        this.toggleHeaderSearch();
                    } else {
                        this.submitForm(event);
                    }
                },

                submitForm (event)
                {
                    // event.preventDefault();
                    // if (this.link !== "") {
                    //     location.href = this.link;
                    // }
                },

                search(input)
                {
                    this.input = input;

                    if (this.searchIndexItems && typeof this.input !== "undefined" && this.input && this.input.length > 2) {
                        return this.searchIndexItems.filter(item => {
                            return this.matchesQuery(item);
                        });
                    } else {
                        return [];
                    }
                },

                matchesQuery (item)
                {
                    const keyword = this.input;
                    return item.title.toLowerCase().includes(keyword.toLowerCase())
                },

                getSearchIndexItems()
                {
                    const config = {
                        headers: {
                            'X-WC-Store-API-Nonce' : document.getElementById('wpnonce').content,
                        }
                    };

                    axios.get('/wp-json/noma/v1/products/search-index/', {}, config)
                        .then(this.getSearchIndexItems__callback)
                        .catch(function (error) {
                            _log(error);
                        }
                    );
                },

                getSearchIndexItems__callback(response)
                {
                    if (typeof response === 'object' && typeof response.data.posts === 'object') {
                        this.searchIndexItems = response.data.posts;
                    } else {
                        this.searchIndexItems = [];
                    }
                }

            },

            created ()
            {
                this.getCartItems();
                this.initWindowScroll();
            }
      });

    }

}